<template>
  <a-layout-content>
    <div class="body-nest">
      <a-table bordered row-key="ID" size="middle" :columns="columns" :data-source="datarow" :pagination="pagination"
        @change="changepage">
        <template slot="title">
          <a-row>
            <a-col style="float: left">
              <a href="javascript:;" @click="add()"><a-button type="primary"><a-icon
                    type="plus"></a-icon>新增</a-button></a>
            </a-col>
          </a-row>
        </template>
        <template slot="State" slot-scope="text, record">
          <a-tag v-if="record.State == '0'" color="red">否</a-tag>
          <a-tag v-else-if="record.State == '1'" color="cyan">是</a-tag>
        </template>
        <template slot="Show" slot-scope="text, record">
          <a-tag v-if="record.Show == '0'" color="red">否</a-tag>
          <a-tag v-else-if="record.Show == '1'" color="cyan">是</a-tag>
        </template>
        <template slot="Operation" slot-scope="text, record">
          <a-tooltip title="编辑">
            <a @click="edit(record)">
              <a-icon type="edit" style="font-size: 22px"></a-icon>
            </a>
          </a-tooltip>
          &nbsp;&nbsp;
          <a-tooltip title="删除">
            <a @click="deleteactive(record)">
              <a-icon type="delete" style="font-size: 22px"></a-icon>
            </a>
          </a-tooltip>
          &nbsp;&nbsp;
          <a-tooltip title="上传活动图片">
            <a href="javascript:;" @click="onUpdateImage(record)">
              <a-icon type="upload" style="font-size: 22px"></a-icon>
            </a>
          </a-tooltip>
          &nbsp;&nbsp;
          <a-tooltip v-if="record.SetUrl=='0'" title="表单配置">
            <a @click="inputset(record)">
              <a-icon type="snippets" style="font-size: 22px"></a-icon>
            </a>
          </a-tooltip>
        </template>
      </a-table>
    </div>

    <!-- 编辑对话框 ------------------------------------->
    <a-modal v-model="editvisible" :title="action == add ? '新增' : '编辑'" @ok="handleOk">
      <a-form-model ref="ruleForm" :rules="rules" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="活动名称" prop="Title" ref="Title">
          <a-input v-model="form.Title" />
        </a-form-model-item>
        <a-form-model-item label="副标题">
          <a-input v-model="form.SubTitle" />
        </a-form-model-item>
        <a-form-model-item label="显示">
          <a-switch checked-children="是" un-checked-children="否" :checked="form.Show == 1"
            @change="swichstate($event,'form.Show')" />
          <span style="color: red;"> 前端是否显示</span>
        </a-form-model-item>
        <a-form-model-item label="开启">
          <a-switch checked-children="是" un-checked-children="否" :checked="form.State == 1"
            @change="swichstate($event,'form.State')" />
          <span style="color: red;"> 是否开启申请</span>
        </a-form-model-item>
        <a-form-model-item label="会员账号显示">
          <a-switch checked-children="是" un-checked-children="否" :checked="form.ShowUserid == 1"
            @change="swichstate($event,'form.ShowUserid')" />
          <span style="color: red;"> 前台是否显示会员账号</span>
        </a-form-model-item>
        <a-form-model-item label="是否外链">
          <a-switch checked-children="是" un-checked-children="否" :checked="form.SetUrl == 1"
            @change="swichstate($event,'form.SetUrl')" />
          <a-input v-if="form.SetUrl == 1" v-model="form.Url" />
        </a-form-model-item>
        <a-form-model-item label="排序字段" prop="Sort" ref="Sort">
          <a-input-number v-model="form.Sort" defaultValue="1" />
        </a-form-model-item>
        <a-form-item label="项目说明">
          <VueTrix inputId="editor" v-model="form.Content" ref="trix" />
        </a-form-item>
      </a-form-model>
    </a-modal>
    <!--END 编辑对话框 ------------------------------------->

    <!-- 上传图片对话框 ------------------------------------->
    <a-modal v-model="visible" title="上传活动图片" @ok="UploadOK">
      <a-form-model :model="formModel" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="活动图片">
          <img style="width: 100px; height: 100px" v-if="pcimageUrl" :src="pcimageUrl" alt="avatar" />
          <a-upload :before-upload="pcUpload" list-type="picture" :file-list="pcfile" :remove="pcRemove">
            <a-button> <a-icon type="upload" /> 选取图片 </a-button>
          </a-upload>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-layout-content>
</template>
<script>
  let datarow = [];
  import lodash from 'lodash';
  import { isNumber } from "../../js/textverify";
  import VueTrix from "vue-trix";

  export default {
    data() {
      return {
        //------table --------
        columns: IninTable(),
        datarow,
        pagination: {
          total: 0,
          pageindex: 1,
          pagesize: 10,
          showTotal: (total) => `共 ${total} 条`,
          showSizeChanger: true, // 可以改变每页个数
          pageSizeOptions: ["10", "20", "30", "50", "100"],
        },
        //---------上传-----------
        visible: false, //弹框状态
        formModel: {}, // 弹框字段
        labelCol: { span: 5 },
        wrapperCol: { span: 16 },
        pcfile: [],
        appfile: [],
        pcimageUrl: false,
        h5imageUrl: false,
        //----------编辑---------
        editvisible: false, //编辑弹窗
        form: {},
        action: 'add',
        rules: {
          Title: [
            { required: true, message: '请输入活动名称', trigger: 'blur' },
          ],
          Sort: [
            { required: true, message: '请输入排序', trigger: 'blur' },
            { validator: isNumber, trigger: 'change' },
          ],
        },
      };
    },
    methods: {
      query() {
        let params = {
          pageindex: this.pagination.pageindex,
          pagesize: this.pagination.pagesize,
        };

        this.axios.post("/customerservice/customerserviceqrylist", params).then((res) => {
          this.datarow = res.data;
          this.pagination.total = res.total;
        });
      },
      //翻页
      changepage(e) {
        this.pagination.pageindex = e.current;
        this.pagination.pagesize = e.pageSize;
        this.query();
      },
      // 创建活动
      add() {
        this.editvisible = true;
        this.action = 'add';
        this.form = { ID: 0, Content: "", Show: 0, Sort: 1, State: 0, Title: "", SetUrl: 0, ShowUserid: 0 };
      },
      //编辑活动
      edit(record) {
        this.editvisible = true;
        this.action = 'edit';
        this.form = lodash.cloneDeep(record);
      },
      handleOk() {
        var urlregex = /(http|https):\/\/([\w.]+\/?)\S*/;
        if (!urlregex.test(this.form.Url) && this.form.Url != "" && this.SetUrl == 1) {
          return this.$message.error(this.form.Url + "请输入正确的地址");
        }
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            var urltype = this.action == "add" ? "customerserviceadd" : "customerserviceedit"
            var _this = this;
            _this.axios.post("/customerservice/" + urltype, this.form).then((res) => {
              if (res.data) {
                if (res.data == "0") {
                  const msg = _this.action === "add" ? "添加成功" : "编辑成功";
                  _this.$message.success(msg);
                }
                else if (res.data == "1") {
                  const msg = "活动名称已存在";
                  _this.$message.error(msg);
                }
                else if (res.data == "2") {
                  const msg = "活动超过上限";
                  _this.$message.error(msg);
                }
                _this.query();
                _this.editvisible = false;
              }
            });
          }
        });
      },
      swichstate(val, flag) {
        if (flag == "form.Show") {
          this.form.Show = val ? 1 : 0;
        }
        else if (flag == "form.State") {
          this.form.State = val ? 1 : 0;
        }
        else if (flag == "form.SetUrl") {
          this.form.SetUrl = val ? 1 : 0;
        }
        else if (flag == "form.ShowUserid") {
          this.form.ShowUserid = val ? 1 : 0;
        }
      },
      //删除
      deleteactive(record) {
        let _this = this;
        const IDList = [];
        IDList.push({ ID: record.ID });

        this.$confirm({
          title: "删除",
          content: "您要确定要删除吗?",
          onOk() {
            _this.axios.post("/customerservice/customerservicedelete", { IDList: IDList }).then((res) => {
              if (res.data) {
                _this.$message.success("删除成功");
                _this.query();
              }
            });
          },
        });
      },
      //上传图片
      onUpdateImage(record) {
        this.formModel = lodash.cloneDeep(record);
        this.appfile = [];
        this.pcfile = [];
        //图片显示
        if (this.formModel.Image !== "") {
          this.pcimageUrl = this.formModel.Image;
        }
        this.visible = true;
      },
      //上传图片
      pcUpload(file) {
        if (!this.isImg(file)) {
          this.$message.error("仅支持上传.jpg、.png、后缀文件");
          return false;
        }
        this.pcfile = [file];
        return false;
      },
      isImg(file) {
        return /\.(jpg|png|JPG|PNG)$/.test(file.name);
      },
      //删除准备上传图片
      pcRemove(file) {
        const index = this.pcfile.indexOf(file);
        const newFileList = this.pcfile.slice();
        newFileList.splice(index, 1);
        this.pcfile = newFileList;
      },
      //上传
      UploadOK() {
        let param = new FormData();
        if (this.pcfile.length > 0) {
          param.append(
            "files",
            this.pcfile[0],
            "." + this.pcfile[0].name.split(".")[1]
          );
        }
        param.append("id", this.formModel.ID); // 添加form表单中其他数据
        let config = {
          headers: { "Content-Type": "multipart/form-data" },
        };
        // 添加请求头
        let _this = this;
        this.axios.post("/customerservice/uploadcontentimage", param, config).then((res) => {
          if (res.data) {
            _this.$message.success("上传成功");
            _this.visible = false;
            _this.query();
          }
        });
      },
      //表单配置
      inputset(record) {
        this.$router.push({
          name: "customerserviceinput",
          params: { Name: record.Name, id: record.ID },
        });
      },


    },
    created() {
      this.query();
    },
    components: {
      VueTrix,
    },
    watch: {
      $route(to, from) {
        if (to.name === "customerservicelist") {
        }
      },
    },
  };

  const IninTable = function IninTable() {
    var header = [];
    header.push({ title: "编号", align: "center", width: 80, dataIndex: "ID" });
    header.push({
      title: "活动名称",
      align: "center",
      dataIndex: "Title",
    });
    header.push({
      title: "开启",
      align: "center",
      dataIndex: "State",
      width: 100,
      scopedSlots: { customRender: "State" },
    });
    header.push({
      title: "显示",
      align: "center",
      dataIndex: "Show",
      width: 100,
      scopedSlots: { customRender: "Show" },
    });
    header.push({
      title: "排序",
      align: "center",
      width: 80,
      sorter: (a, b) => a.Sort - b.Sort,
      dataIndex: "Sort",
    });
    header.push({
      title: "创建时间",
      align: "center",
      width: 400,
      sorter: (a, b) =>
        new Date(a.Fdt.replace(/[\u4e00-\u9fa5]/g, "")).getTime() -
        new Date(b.Fdt.replace(/[\u4e00-\u9fa5]/g, "")).getTime(),
      dataIndex: "Fdt",
    });
    header.push({
      title: "操作",
      align: "center",
      width: 300,
      scopedSlots: { customRender: "Operation" },
    });
    return header;
  };
</script>

<style>
  .clearline {
    border-top: solid #acc0d8 1px;
    margin: 10px 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/customerservice/customerservicelist.vue